import { IProvenancesStore } from './index'

export default {
  modal: {
    open: false,
  },
  provenances: [],
  request: {
    errMessage: '',
    isLoading: false,
  },
} as IProvenancesStore
